import { toastError } from "@mgdx/ui/components/Toast";
import { useCallback, useEffect, useState } from "react";

import { useUpdateAgreementMutation } from "../../hooks/patient/useUpdateAgreementMutation";
import { AgreementNewTermsConfirmModal } from "./AgreementNewTermsConfirmModal";
import { AgreementNewTermsReasonModal } from "./AgreementNewTermsReasonModal";
import { AgreementNewTermsWithdrawModal } from "./AgreementNewTermsWithdrawModal";

export const AgreementNewTermsMain = () => {
  const [dialogType, setDialogType] = useState<"confirm" | "reason" | "withdraw" | "agreed">("confirm");

  const { mutate, isPending, isSuccess, isError, error } = useUpdateAgreementMutation();

  const onClickAgreement = useCallback(() => {
    mutate();
  }, [mutate]);

  const onClickShowReason = useCallback(() => {
    setDialogType("reason");
  }, []);

  const onClickShowWithdraw = useCallback(() => {
    setDialogType("withdraw");
  }, []);

  useEffect(() => {
    if (isSuccess) {
      setDialogType("agreed");
    }
  }, [isSuccess]);

  useEffect(() => {
    if (isError) {
      // APIのエラーが発生した場合は同意ダイアログを消しサービス利用できるようにする
      setDialogType("agreed");
    }
  }, [isError]);

  useEffect(() => {
    if (error) {
      toastError("同意に失敗しました");
    }
  }, [error]);

  if (dialogType === "confirm") {
    return (
      <AgreementNewTermsConfirmModal
        isLoading={isPending}
        onClickAgreement={onClickAgreement}
        onClickShowReason={onClickShowReason}
      />
    );
  }

  if (dialogType === "reason") {
    return (
      <AgreementNewTermsReasonModal
        isLoading={isPending}
        onClickAgreement={onClickAgreement}
        onClickShowWithdraw={onClickShowWithdraw}
      />
    );
  }

  if (dialogType === "withdraw") {
    return <AgreementNewTermsWithdrawModal onClickShowReason={onClickShowReason} />;
  }

  return null;
};
